var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2227(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "scale(-1, 1) translate(-15.468670, 1)",
    fillRule: "evenodd",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    strokeWidth: 1.96,
    fill: "#FFFFFF",
    transform: "translate(7.169076, 13.944085) scale(-1, 1) translate(-7.169076, -13.944085)",
    d: "M6.53864637,27.888169 C5.71246671,27.888169 4.7588408,27.4443803 3.87594244,26.6284917 C2.721751,25.5633987 0.0368379365,22.2213279 0.0368379365,14.2740954 C0.0368379365,13.355794 0.0259042106,12.659387 0.0156538426,12.0244277 C0.00232836414,11.1470915 -0.00928871961,10.3892369 0.0108703375,9.34804015 C0.0120372638,9.30676933 0.0166084722,9.26566493 0.0245374948,9.2251448 C1.08989241,3.88636602 3.75703817,1.38578705 5.25222518,0.370193539 C5.92635772,-0.0848606277 7.70445489,-0.10500181 8.31366843,0.225450128 C10.5608908,1.45167261 13.3055977,4.58686951 13.966063,7.98253627 C14.2783576,9.58700332 14.261957,10.9934723 14.2394062,12.7754549 C14.2339393,13.2465537 14.2281308,13.7415489 14.2281308,14.2740954 C14.2281308,15.3084646 14.2551234,16.3803851 14.2824577,17.4557194 C14.3104754,18.55495 14.3381514,19.6610082 14.3381514,20.74317 C14.3381514,20.8101271 14.3287726,20.8767548 14.3104754,20.9411681 C13.8416919,22.5695314 11.9077891,27.8813415 6.71256095,27.8813415 C6.65584224,27.8847553 6.59775683,27.888169 6.53864637,27.888169 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hook",
    transform: "translate(-8.000000, -21.000000) translate(0.000000, 13.000000)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "extracted",
    stroke: "none",
    strokeLinecap: "square",
    x1: 2.12918175,
    y1: 5.62319304,
    x2: 11.7346352,
    y2: 23.3688235
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2227);
export default __webpack_public_path__ + "static/media/22-27.0e70f70cdf0f47f48ec4a981898c180c.svg";
export { ForwardRef as ReactComponent };